import React from 'react';
import PropTypes from 'prop-types';
import LayoutContext from '../context/layout-context';

const ManagementLayout = ({ children }) => {
  const layoutContextValue = {}; // adjust or fill as needed

  return <div>{children}</div>;
};

ManagementLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ManagementLayout;
